import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var CloudDataTransferSvg = function CloudDataTransferSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    d: "M5 17.659A6.003 6.003 0 0 1 6.328 6.037 6 6 0 0 1 18 8a5 5 0 0 1 1 9.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    d: "M10 23v-9h-.5L7 16.5M14 13v9h.5l2.5-2.5"
  }));
};
export var CloudDataTransfer = function CloudDataTransfer(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: CloudDataTransferSvg
  }));
};